// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p1V8H","col":"styles_col__AjWpg"};